/*
    Imports
--------------------------*/
import { ReadMoreBtn } from 'vendor-js/read-more';
import { setCookie, hasCookie } from 'common-js/cooke-util';
const browseMetaDesc = document.querySelector('.js--browse__meta--description');

if (browseMetaDesc) {
    new ReadMoreBtn({
        selectors: browseMetaDesc,
        readMoreBtnText: 'Read More',
        length: 500,
        sliceLength: 260,
    });
}

$('#price-range').ionRangeSlider({
    input_values_separator: 'to',
    min: $('#price-range').attr('min'),
    max: $('#price-range').attr('max'),
    from: $('#price-range').attr('from'),
    to: $('#price-range').attr('to'),
    type: 'double',
    prefix: '৳',
    grid: true,
});

$('#discount-range').ionRangeSlider({
    input_values_separator: 'to',
    min: $('#discount-range').attr('min'),
    max: $('#discount-range').attr('max'),
    from: $('#discount-range').attr('from'),
    to: $('#discount-range').attr('to'),
    type: 'double',
    postfix: '%',
    grid: true,
});

$('#js--browse-sidebar-form input').on('change', function () {
    $('#js--browse-sidebar-form').submit();
});

$('.js--filter-item-search').on('keyup', function (e) {
    const inputValue = $(this).val().trim();

    $($(this).data('search-target') + ' .rok-checkbox').each((i, item) => {

        if ($(item).data('search-key').indexOf(inputValue) > -1 ||
            $(item).data('search-key').toUpperCase().indexOf(inputValue.toUpperCase()) > -1) {
            $(item).show();
        } else {
            $(item).hide();
        }
    });
});

const contextPath = $('meta[name=context-path]').attr('content');
const searchBox = $('#inner_search_box');
if (searchBox.length > 0) {
    $('head').append('<link rel="stylesheet" href="https://www.rokomari.com/static/new/css/jquery-ui.css" type="text/css"/>');
    $.getScript('https://code.jquery.com/ui/1.12.1/jquery-ui.js').done(() => {
        searchBox.autocomplete({
            source: `${contextPath}/data/common-autocomplete/?${searchBox.attr('data-search')}`,
            select: function (event, ui) {
                document.location.href = `${contextPath}/book/${ui.item.id}`
            }
        });
    });
}

/**
 * Follow/Unfollow Author
 */

const formatNumber = (number) => number >= 1000 ? (number / 1000).toFixed(1) + 'K' : number.toString();

$('#js--follower-count').text(formatNumber(+$('#js--follower-count').data('count')));

function updateFollower(element, params, identifier, resetIdentifier) {
    $.get("/book/author/follower-status-add-update", params, function (data) {
        if (data.result) {
            element.attr("id", `js--btn-${identifier}-author`);
            $('#js--follower-count').text(formatNumber(+data.message));
            $('#js--follower-text').text(`${+data.message > 1 ? 'followers' : 'follower'}`);
            +data.message < 1 ? $('#js--follower-text').parent().addClass('d-none') : $('#js--follower-text').parent().removeClass('d-none');
        } else {
            if (data.message == 'Login') {
                window.location.href = "/login";
            } else {
                alert(data.message);
            }
            element.attr("id", `js--btn-${resetIdentifier}-author`);
        }
    });
}

$(document).on('click', '#js--btn-follow-author', function () {
    let params = "peopleId=" + $(this).data('peopleid') + "&status=FOLLOWING";
    if ($('meta[name=user-id]').length) {
        updateFollower($(this), params, 'unfollow', 'follow');
        $(this).text('Following');
    } else {
        window.location.href = "/login";
    }
});

$(document).on('click', '#js--btn-unfollow-author', function () {
    if (confirm('Are you sure want to unfollow this author?')) {
        let params = "peopleId=" + $(this).data('peopleid') + "&status=FOLLOWED";
        updateFollower($(this), params, 'follow', 'unfollow');
        $(this).text('Follow');
    }
});

$(document).ready(function () {
    $('#exp').click(function () {
        window.open('data:application/vnd.ms-excel,' + '<table>' + encodeURIComponent($('#dataTable').html()) + '</table>');
    });
});

$('input[name="search_type"]').on('change', function () {
    location.replace(contextPath + '/search?term=' + $('input[name="term"]').val() + '&search_type=' + $(this).val())
})

$(function() {
    const categoryList = $('#specific-category-list');

    if (categoryList.length) {
        const categoryId = categoryList.data('categoryid')
        const parentCategoryIds = categoryList.data('parentcategoryid').split('.');
    
        const parentCat = parseInt(parentCategoryIds[parentCategoryIds.length - 1])
    
        $.get(`/sub-categories?categoryId=${parentCat}`, (res) => {
            if (res.length > 0) {
                let text = '';
                categoryList.parent().removeClass('d-none');
    
                switch (parentCat) {
                    case 1350:
                        text = 'HSC বিজ্ঞান ১ম বর্ষের ক্যাটাগরি ';
                        break;
                    case 3454:
                        text = 'HSC বিজ্ঞান ২য় বর্ষের ক্যাটাগরি ';
                        break;
                    case 1351:
                        text = 'HSC ব্যাবসায় শিক্ষা ১ম বর্ষের ক্যাটাগরি ';
                        break;
                    case 3455:
                        text = 'HSC ব্যাবসায় শিক্ষা ২য় বর্ষের ক্যাটাগরি';
                        break;
                    case 1352:
                        text = 'HSC মানবিক ১ম বর্ষের ক্যাটাগরি';
                        break;
                    case 3456:
                        text = 'HSC মানবিক ২য় বর্ষের ক্যাটাগরি';
                        break;
                    default:
                        text = '';
                        break;
                }
                
                $('#specific-category__title').text(text);
    
                $('#specific-category-list').append(res.map(elm => {
                    if (categoryId == elm.id) {
                        return `<a href="/book/category/${elm.id}" style="color: white; border-color:#0397D3; background-color: #0397D3;" target="" class="specific-category__item ">${elm.name}</a>`
                    }
                    return `<a href="/book/category/${elm.id}" target="" class="specific-category__item ">${elm.name}</a>`
                }))
            }
    
    
        })
    }
})